import { createFileRoute } from '@tanstack/react-router';

import { SynchroRdv } from '@/features/documentation/synchro-rdv';

export const Route = createFileRoute('/_app/docs/appointment-sync')({
  component: SynchroRdv,
});
